import { Item as ItemType } from 'typings'
import { CollectionsRule } from './CollectionsRule'
import { SkusRule } from './SkusRule'
import { SCOPE_OPTIONS } from './typing'

type Props = {
  config: {
    [key in SCOPE_OPTIONS]?: ItemType[]
  }
  onEdit: () => void
  onRemove: (field: string) => void
}

const itemMap = {
  [SCOPE_OPTIONS.SKUS]: SkusRule,
  [SCOPE_OPTIONS.COLLECTIONS]: CollectionsRule,
}

type ItemProps = Omit<Props, 'config'> & {
  id: SCOPE_OPTIONS
  config: ItemType[]
}

const Item = (props: ItemProps) => {
  const { id, config, onEdit, onRemove } = props
  const Component = itemMap[id]

  if (Component)
    return <Component config={config} onEdit={onEdit} onRemove={onRemove} />

  return null
}

export function ItemsView(props: Props) {
  const { config, onEdit, onRemove } = props

  return Object.values(SCOPE_OPTIONS).map(
    (field) =>
      config[field] && (
        <Item
          key={field}
          config={config[field]}
          onRemove={onRemove}
          onEdit={onEdit}
          id={field}
        />
      )
  )
}
